import { Link } from '@tanstack/react-router'

import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Loader,
} from '@/components'

interface InvitationCardProps {
  title: string
  description?: string
  loading?: boolean
  actions?: { to: string; label: string }[]
}
export const InvitationCard = ({
  title,
  description,
  loading = false,
  actions = [],
}: InvitationCardProps) => {
  const actionsSize = actions.length
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      {loading && (
        <CardContent>
          <div className="flex justify-center py-4">
            <Loader size="md" />
          </div>
        </CardContent>
      )}
      {actionsSize > 0 && (
        <CardFooter className="flex gap-3">
          {actions.map(({ to, label }, i) => (
            <Button
              key={`${to}-${i}`}
              theme={actionsSize === i + 1 ? 'default' : 'outline'}
              asChild
            >
              <Link to={to}>{label}</Link>
            </Button>
          ))}
        </CardFooter>
      )}
    </Card>
  )
}
